import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../components/Common/TextInput';
import CallOut from '../components/Common/CallOut';
import Notification from '../components/Common/Notification';
import ActivityLoader from '../components/Common/ActivityLoader';
import ajaxPayee from '../util/remote/ajaxPayee';
import { useVendor } from '../DataStore/VendorContext';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
        loading:false,
        vendorName:'',
        description:'',
        address:'',
        phoneNumber:'',
        emailAddress:''
}

const NewVendor = () => {

    const {getVendorListing} = useVendor();
    const [currentNotify, setNotify] = useState(null);

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
        if(currentNotify){
            setTimeout(() => {
                setNotify(null);
            }, 5000);
        }
    }, [currentNotify]);


    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }
        dispatch({type: 'loading', value: true});
        const server_response = await ajaxPayee.addVendor(
            state.vendorName, state.description, state.address, state.phoneNumber, state.emailAddress
        );
        dispatch({type: 'loading', value: false});
        if(server_response?.status === "OK"){
            dispatch({type: 'RESET'});

            /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
            setTimeout(() => {
                getVendorListing(true);
            }, 5000);
            
           
            setNotify(<Notification type='success' message={server_response.message} />);
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>);
        }

    }


    return (
        <div className="card-body">

            <CallOut 
                title="Vendors"
                description="Add new vendor for your transaction payees and funds sources."
             />
            {currentNotify}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>
                           

                        <TextInput
                            type="text"
                            label="Vendor Name"
                            placeholder="Vendor Name"
                            leftIcon="fa fa-user"
                            value={state.vendorName}
                            onChange={e => dispatch({type: 'vendorName', value: e.target.value})}
                            required
                            wrap
                            />

                        <TextInput
                            type="textarea"
                            label="Business Description"
                            placeholder="Business Description"
                            leftIcon="fa fa-list"
                            value={state.description}
                            onChange={e => dispatch({type: 'description', value: e.target.value})}
                            required
                            wrap
                            />


                        <TextInput
                            type="text"
                            label="Vendor Address"
                            placeholder="Vendor Address"
                            leftIcon="fa fa-map-pin"
                            value={state.address}
                            onChange={e => dispatch({type: 'address', value: e.target.value})}
                            wrap
                            />
        
                          
                        <TextInput
                            type="text"
                            label="Phone Number"
                            placeholder="Phone Number"
                            leftIcon="fa fa-phone"
                            value={state.phoneNumber}
                            onChange={e => dispatch({type: 'phoneNumber', value: e.target.value})}
                            wrap
                            />

                        <TextInput
                            type="email"
                            label="Email Address"
                            placeholder="Email Address"
                            leftIcon="fa fa-envelope"
                            value={state.emailAddress}
                            onChange={e => dispatch({type: 'emailAddress', value: e.target.value})}
                            wrap
                            />


                        

                            <div className="text-right">
                               {!state.loading && <button type="submit" className="btn btn-lg btn-success">Save Vendor</button>}
                               {state.loading && <ActivityLoader />}
                            </div>

                        </form> 


        </div>
    );
};

export default NewVendor;